import { render } from "./template-preview.vue?vue&type=template&id=1e75566e&scoped=true"
import script from "./template-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./template-preview.vue?vue&type=script&setup=true&lang=js"

import "./template-preview.vue?vue&type=style&index=0&id=1e75566e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e75566e"],['__file',"resources/js/v2/modules/whatsapp/pages/templates/create-edit/components/template-preview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e75566e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e75566e', __exports__)) {
    console.log('reload')
    api.reload('1e75566e', __exports__)
  }
  
  module.hot.accept("./template-preview.vue?vue&type=template&id=1e75566e&scoped=true", () => {
    console.log('re-render')
    api.rerender('1e75566e', render)
  })

}


export default __exports__